import React from 'react';

import { Label } from '@admin/components/helpers/label';
import { ORDER_STATE_TO_NAME, ORDER_STATE_TO_KIND } from '@admin/constants/order_state';
import { OrderStateEnum as Order__State } from '@admin/schema';

export const State: React.FC<{ state: Order__State; waitlisted: boolean }> = ({ state, waitlisted }) => (
  <Label kind={ORDER_STATE_TO_KIND[state]}>
    {ORDER_STATE_TO_NAME[state]}
    {state === Order__State.Pending && waitlisted && ' - Customer is on the waitlist for their requested date'}
    {state === Order__State.Pending && !waitlisted && ' - Customer has not yet selected a date'}
  </Label>
);
